// extracted by mini-css-extract-plugin
module.exports = {"lightDivider":"LrvDivider_lightDivider__2PiDS","darkDivider":"LrvDivider_darkDivider__KAj9a"};